import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};

export const EmptyShoppingFlowSavedPlanResults = ({
  style,
  className,
}: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        width="164"
        height="144"
        viewBox="0 0 180 148"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <style>
          {`
  /* Carousel "favorite" animation — each plan gets liked in turn on a 6s loop.
     Phase delays stagger the three cards: card 1 @0-2s, card 2 @2-4s, card 3 @4-6s. */
  .like-heart-saved-plans {
    transform-box: fill-box;
    transform-origin: center;
    animation: heartPop-saved-plans 6s ease-in-out infinite, heartFill-saved-plans 6s ease-in-out infinite;
  }
  .ph2-saved-plans { animation-delay: 2s; }
  .ph3-saved-plans { animation-delay: 4s; }
  @keyframes heartPop-saved-plans {
    0%            { transform: scale(1); }
    8%            { transform: scale(1.2); }
    15%           { transform: scale(0.96); }
    22%, 100%     { transform: scale(1); }
  }
  @keyframes heartFill-saved-plans {
    0%, 5%    { stroke: #1A1721; fill: rgba(115,46,247,0); }
    12%, 28%  { stroke: #732EF7; fill: #732EF7; }
    34%, 100% { stroke: #1A1721; fill: rgba(115,46,247,0); }
  }
  .spark-saved-plans {
    fill: #732EF7;
    opacity: 0;
    transform-box: fill-box;
    transform-origin: center;
    animation: sparkle-saved-plans 6s ease-out infinite;
  }
  .gold-saved-plans { fill: #FFC53D; }
  @keyframes sparkle-saved-plans {
    0%, 5%  { opacity: 0; transform: scale(0) rotate(-20deg); }
    13%     { opacity: 1; transform: scale(1) rotate(0deg); }
    24%     { opacity: 0; transform: scale(0.3) rotate(15deg); }
    100%    { opacity: 0; transform: scale(0) rotate(15deg); }
  }
  @media (prefers-reduced-motion: reduce) {
    .like-heart-saved-plans { animation: none; stroke: #732EF7; fill: #732EF7; }
    .spark-saved-plans { animation: none; opacity: 0; }
  }
  `}
        </style>
        <g filter="url(#filter0_d_12162_48696)">
          <mask id="path-1-inside-1_12162_48696" fill="white">
            <path d="M6 8C6 3.58172 9.58172 0 14 0L166 0C170.418 0 174 3.58172 174 8V32C174 36.4183 170.418 40 166 40H14C9.58172 40 6 36.4183 6 32V8Z" />
          </mask>
          <path
            d="M6 8C6 3.58172 9.58172 0 14 0L166 0C170.418 0 174 3.58172 174 8V32C174 36.4183 170.418 40 166 40H14C9.58172 40 6 36.4183 6 32V8Z"
            fill="white"
            shapeRendering="crispEdges"
          />
          <path
            d="M14 0V1L166 1V0V-1L14 -1V0ZM174 8H173V32H174H175V8H174ZM166 40V39H14V40V41H166V40ZM6 32H7V8H6H5V32H6ZM14 40V39C10.134 39 7 35.866 7 32H6H5C5 36.9706 9.02944 41 14 41V40ZM174 32H173C173 35.866 169.866 39 166 39V40V41C170.971 41 175 36.9706 175 32H174ZM166 0V1C169.866 1 173 4.13401 173 8H174H175C175 3.02944 170.971 -1 166 -1V0ZM14 0V-1C9.02944 -1 5 3.02944 5 8H6H7C7 4.13401 10.134 1 14 1V0Z"
            fill="#EDEFF6"
            mask="url(#path-1-inside-1_12162_48696)"
          />
          <path
            d="M16 9.71167H53.8525C54.8608 9.71167 55.6787 10.5286 55.6787 11.5369V28.4636C55.6785 29.4717 54.8607 30.2888 53.8525 30.2888H16C14.9919 30.2888 14.175 29.4717 14.1748 28.4636V11.5369C14.1748 10.5286 14.9917 9.71167 16 9.71167Z"
            fill="white"
          />
          <path
            d="M16 9.71167H53.8525C54.8608 9.71167 55.6787 10.5286 55.6787 11.5369V28.4636C55.6785 29.4717 54.8607 30.2888 53.8525 30.2888H16C14.9919 30.2888 14.175 29.4717 14.1748 28.4636V11.5369C14.1748 10.5286 14.9917 9.71167 16 9.71167Z"
            stroke="#D9DBDF"
            strokeWidth="0.348772"
          />
          <g>
            <rect
              x="22.5"
              y="15.5"
              width="9"
              height="9"
              rx="2.5"
              fill="#DEE1E7"
            />
            <circle cx="27" cy="20.0" r="2.4" fill="white" />
            <text
              x="34"
              y="22.45"
              fontFamily="Arial, Helvetica, sans-serif"
              fontSize="7"
              fontWeight="700"
              fill="#C5C8D0"
            >
              Aria
            </text>
          </g>
          <path
            d="M63.8527 16C63.8527 14.8954 64.7481 14 65.8527 14H83.8527C84.9572 14 85.8527 14.8954 85.8527 16V16C85.8527 17.1046 84.9572 18 83.8527 18H65.8527C64.7481 18 63.8527 17.1046 63.8527 16V16Z"
            fill="#EDEFF6"
          />
          <path
            d="M63.8527 24C63.8527 22.8954 64.7481 22 65.8527 22H117.853C118.957 22 119.853 22.8954 119.853 24V24C119.853 25.1046 118.957 26 117.853 26H65.8527C64.7481 26 63.8527 25.1046 63.8527 24V24Z"
            fill="#EDEFF6"
          />
          <path
            d="M127.853 12C127.853 9.79086 129.644 8 131.853 8H162C164.209 8 166 9.79086 166 12V28C166 30.2091 164.209 32 162 32H131.853C129.644 32 127.853 30.2091 127.853 28V12Z"
            fill="#F7F9FB"
          />
          <path
            className="like-heart-saved-plans"
            d="M159.955 17.713L156.547 21.0884L153.139 17.713C152.914 17.4942 152.737 17.2313 152.619 16.9407C152.501 16.6502 152.444 16.3383 152.452 16.0248C152.46 15.7112 152.533 15.4028 152.667 15.1188C152.8 14.8349 152.991 14.5817 153.227 14.3751C153.463 14.1685 153.739 14.0129 154.038 13.9183C154.337 13.8237 154.653 13.792 154.964 13.8253C155.276 13.8586 155.578 13.9561 155.85 14.1117C156.123 14.2672 156.36 14.4775 156.547 14.7293C156.735 14.4793 156.972 14.2709 157.245 14.117C157.517 13.963 157.818 13.867 158.129 13.8347C158.44 13.8025 158.754 13.8348 159.052 13.9296C159.35 14.0245 159.625 14.1798 159.86 14.3859C160.096 14.5919 160.286 14.8443 160.419 15.1273C160.552 15.4102 160.625 15.7176 160.634 16.0301C160.643 16.3427 160.587 16.6537 160.471 16.9438C160.354 17.2338 160.178 17.4966 159.955 17.7157"
            stroke="#1A1721"
            strokeWidth="0.817956"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g filter="url(#filter1_d_12162_48696)">
          <mask id="path-9-inside-2_12162_48696" fill="white">
            <path d="M6 56C6 51.5817 9.58172 48 14 48H166C170.418 48 174 51.5817 174 56V80C174 84.4183 170.418 88 166 88H14C9.58172 88 6 84.4183 6 80V56Z" />
          </mask>
          <path
            d="M6 56C6 51.5817 9.58172 48 14 48H166C170.418 48 174 51.5817 174 56V80C174 84.4183 170.418 88 166 88H14C9.58172 88 6 84.4183 6 80V56Z"
            fill="white"
            shapeRendering="crispEdges"
          />
          <path
            d="M14 48V49H166V48V47H14V48ZM174 56H173V80H174H175V56H174ZM166 88V87H14V88V89H166V88ZM6 80H7V56H6H5V80H6ZM14 88V87C10.134 87 7 83.866 7 80H6H5C5 84.9706 9.02944 89 14 89V88ZM174 80H173C173 83.866 169.866 87 166 87V88V89C170.971 89 175 84.9706 175 80H174ZM166 48V49C169.866 49 173 52.134 173 56H174H175C175 51.0294 170.971 47 166 47V48ZM14 48V47C9.02944 47 5 51.0294 5 56H6H7C7 52.134 10.134 49 14 49V48Z"
            fill="#EDEFF6"
            mask="url(#path-9-inside-2_12162_48696)"
          />
          <path
            d="M16 57.7117H53.8525C54.8608 57.7117 55.6787 58.5286 55.6787 59.5369V76.4636C55.6785 77.4717 54.8607 78.2888 53.8525 78.2888H16C14.9919 78.2888 14.175 77.4717 14.1748 76.4636V59.5369C14.1748 58.5286 14.9917 57.7117 16 57.7117Z"
            fill="white"
          />
          <path
            d="M16 57.7117H53.8525C54.8608 57.7117 55.6787 58.5286 55.6787 59.5369V76.4636C55.6785 77.4717 54.8607 78.2888 53.8525 78.2888H16C14.9919 78.2888 14.175 77.4717 14.1748 76.4636V59.5369C14.1748 58.5286 14.9917 57.7117 16 57.7117Z"
            stroke="#D9DBDF"
            strokeWidth="0.348772"
          />
          <g>
            <rect
              x="19.43"
              y="63.5"
              width="9"
              height="9"
              rx="2.5"
              fill="#DEE1E7"
            />
            <rect
              x="23.03"
              y="65.5"
              width="1.8"
              height="5"
              rx="0.7"
              fill="white"
            />
            <rect
              x="21.43"
              y="67.1"
              width="5"
              height="1.8"
              rx="0.7"
              fill="white"
            />
            <text
              x="30.93"
              y="70.45"
              fontFamily="Arial, Helvetica, sans-serif"
              fontSize="7"
              fontWeight="700"
              fill="#C5C8D0"
            >
              Verda
            </text>
          </g>
          <path
            d="M63.8527 64C63.8527 62.8954 64.7481 62 65.8527 62H83.8527C84.9572 62 85.8527 62.8954 85.8527 64V64C85.8527 65.1046 84.9572 66 83.8527 66H65.8527C64.7481 66 63.8527 65.1046 63.8527 64V64Z"
            fill="#EDEFF6"
          />
          <path
            d="M63.8527 72C63.8527 70.8954 64.7481 70 65.8527 70H117.853C118.957 70 119.853 70.8954 119.853 72V72C119.853 73.1046 118.957 74 117.853 74H65.8527C64.7481 74 63.8527 73.1046 63.8527 72V72Z"
            fill="#EDEFF6"
          />
          <path
            d="M127.853 60C127.853 57.7909 129.644 56 131.853 56H162C164.209 56 166 57.7909 166 60V76C166 78.2091 164.209 80 162 80H131.853C129.644 80 127.853 78.2091 127.853 76V60Z"
            fill="#F7F9FB"
          />
          <path
            className="like-heart-saved-plans ph2-saved-plans"
            d="M159.955 65.713L156.547 69.0884L153.139 65.713C152.914 65.4942 152.737 65.2313 152.619 64.9407C152.501 64.6502 152.444 64.3383 152.452 64.0248C152.46 63.7112 152.533 63.4028 152.667 63.1188C152.8 62.8349 152.991 62.5817 153.227 62.3751C153.463 62.1685 153.739 62.0129 154.038 61.9183C154.337 61.8237 154.653 61.792 154.964 61.8253C155.276 61.8586 155.578 61.9561 155.85 62.1117C156.123 62.2672 156.36 62.4775 156.547 62.7293C156.735 62.4793 156.972 62.2709 157.245 62.117C157.517 61.963 157.818 61.867 158.129 61.8347C158.44 61.8025 158.754 61.8348 159.052 61.9296C159.35 62.0245 159.625 62.1798 159.86 62.3859C160.096 62.5919 160.286 62.8443 160.419 63.1273C160.552 63.4102 160.625 63.7176 160.634 64.0301C160.643 64.3427 160.587 64.6537 160.471 64.9438C160.354 65.2338 160.178 65.4966 159.955 65.7157"
            stroke="#1A1721"
            strokeWidth="0.817956"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g filter="url(#filter2_d_12162_48696)">
          <mask id="path-17-inside-3_12162_48696" fill="white">
            <path d="M6 104C6 99.5817 9.58172 96 14 96H166C170.418 96 174 99.5817 174 104V128C174 132.418 170.418 136 166 136H14C9.58172 136 6 132.418 6 128V104Z" />
          </mask>
          <path
            d="M6 104C6 99.5817 9.58172 96 14 96H166C170.418 96 174 99.5817 174 104V128C174 132.418 170.418 136 166 136H14C9.58172 136 6 132.418 6 128V104Z"
            fill="white"
            shapeRendering="crispEdges"
          />
          <path
            d="M14 96V97H166V96V95H14V96ZM174 104H173V128H174H175V104H174ZM166 136V135H14V136V137H166V136ZM6 128H7V104H6H5V128H6ZM14 136V135C10.134 135 7 131.866 7 128H6H5C5 132.971 9.02944 137 14 137V136ZM174 128H173C173 131.866 169.866 135 166 135V136V137C170.971 137 175 132.971 175 128H174ZM166 96V97C169.866 97 173 100.134 173 104H174H175C175 99.0294 170.971 95 166 95V96ZM14 96V95C9.02944 95 5 99.0294 5 104H6H7C7 100.134 10.134 97 14 97V96Z"
            fill="#EDEFF6"
            mask="url(#path-17-inside-3_12162_48696)"
          />
          <path
            d="M16 105.712H53.8525C54.8608 105.712 55.6787 106.529 55.6787 107.537V124.464C55.6785 125.472 54.8607 126.289 53.8525 126.289H16C14.9919 126.289 14.175 125.472 14.1748 124.464V107.537C14.1748 106.529 14.9917 105.712 16 105.712Z"
            fill="white"
          />
          <path
            d="M16 105.712H53.8525C54.8608 105.712 55.6787 106.529 55.6787 107.537V124.464C55.6785 125.472 54.8607 126.289 53.8525 126.289H16C14.9919 126.289 14.175 125.472 14.1748 124.464V107.537C14.1748 106.529 14.9917 105.712 16 105.712Z"
            stroke="#D9DBDF"
            strokeWidth="0.348772"
          />
          <g>
            <rect
              x="20.79"
              y="111.5"
              width="9"
              height="9"
              rx="2.5"
              fill="#DEE1E7"
            />
            <path d="M25.29 112.8 L28.18 118.6 H22.4 Z" fill="white" />
            <text
              x="32.29"
              y="118.45"
              fontFamily="Arial, Helvetica, sans-serif"
              fontSize="7"
              fontWeight="700"
              fill="#C5C8D0"
            >
              Nuvo
            </text>
          </g>
          <path
            d="M63.8527 112C63.8527 110.895 64.7481 110 65.8527 110H83.8527C84.9572 110 85.8527 110.895 85.8527 112V112C85.8527 113.105 84.9572 114 83.8527 114H65.8527C64.7481 114 63.8527 113.105 63.8527 112V112Z"
            fill="#EDEFF6"
          />
          <path
            d="M63.8527 120C63.8527 118.895 64.7481 118 65.8527 118H117.853C118.957 118 119.853 118.895 119.853 120V120C119.853 121.105 118.957 122 117.853 122H65.8527C64.7481 122 63.8527 121.105 63.8527 120V120Z"
            fill="#EDEFF6"
          />
          <path
            d="M127.853 108C127.853 105.791 129.644 104 131.853 104H162C164.209 104 166 105.791 166 108V124C166 126.209 164.209 128 162 128H131.853C129.644 128 127.853 126.209 127.853 124V108Z"
            fill="#F7F9FB"
          />
          <path
            className="like-heart-saved-plans ph3-saved-plans"
            d="M159.955 113.713L156.547 117.088L153.139 113.713C152.914 113.494 152.737 113.231 152.619 112.941C152.501 112.65 152.444 112.338 152.452 112.025C152.46 111.711 152.533 111.403 152.667 111.119C152.8 110.835 152.991 110.582 153.227 110.375C153.463 110.168 153.739 110.013 154.038 109.918C154.337 109.824 154.653 109.792 154.964 109.825C155.276 109.859 155.578 109.956 155.85 110.112C156.123 110.267 156.36 110.478 156.547 110.729C156.735 110.479 156.972 110.271 157.245 110.117C157.517 109.963 157.818 109.867 158.129 109.835C158.44 109.803 158.754 109.835 159.052 109.93C159.35 110.024 159.625 110.18 159.86 110.386C160.096 110.592 160.286 110.844 160.419 111.127C160.552 111.41 160.625 111.718 160.634 112.03C160.643 112.343 160.587 112.654 160.471 112.944C160.354 113.234 160.178 113.497 159.955 113.716"
            stroke="#1A1721"
            strokeWidth="0.817956"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g className="sparkles-saved-plans">
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '0s' }}
            d="M156.50 8.30 C156.96 9.44 157.26 9.74 158.40 10.20 C157.26 10.66 156.96 10.96 156.50 12.10 C156.04 10.96 155.74 10.66 154.60 10.20 C155.74 9.74 156.04 9.44 156.50 8.30 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '0.06s' }}
            d="M162.74 12.28 C163.10 13.19 163.34 13.44 164.26 13.80 C163.34 14.16 163.10 14.41 162.74 15.32 C162.37 14.41 162.13 14.16 161.22 13.80 C162.13 13.44 162.37 13.19 162.74 12.28 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '0.12s' }}
            d="M162.74 19.20 C163.17 20.28 163.46 20.57 164.54 21.00 C163.46 21.43 163.17 21.72 162.74 22.80 C162.30 21.72 162.01 21.43 160.93 21.00 C162.01 20.57 162.30 20.28 162.74 19.20 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '0.04s' }}
            d="M156.50 23.08 C156.86 23.99 157.11 24.24 158.02 24.60 C157.11 24.96 156.86 25.21 156.50 26.12 C156.14 25.21 155.89 24.96 154.98 24.60 C155.89 24.24 156.14 23.99 156.50 23.08 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '0.10s' }}
            d="M150.26 19.29 C150.68 20.32 150.95 20.59 151.97 21.00 C150.95 21.41 150.68 21.68 150.26 22.71 C149.85 21.68 149.58 21.41 148.55 21.00 C149.58 20.59 149.85 20.32 150.26 19.29 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '0.15s' }}
            d="M150.26 12.18 C150.65 13.15 150.91 13.41 151.88 13.80 C150.91 14.19 150.65 14.45 150.26 15.41 C149.88 14.45 149.62 14.19 148.65 13.80 C149.62 13.41 149.88 13.15 150.26 12.18 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '2s' }}
            d="M156.50 56.30 C156.96 57.44 157.26 57.74 158.40 58.20 C157.26 58.66 156.96 58.96 156.50 60.10 C156.04 58.96 155.74 58.66 154.60 58.20 C155.74 57.74 156.04 57.44 156.50 56.30 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '2.06s' }}
            d="M162.74 60.28 C163.10 61.19 163.34 61.44 164.26 61.80 C163.34 62.16 163.10 62.41 162.74 63.32 C162.37 62.41 162.13 62.16 161.22 61.80 C162.13 61.44 162.37 61.19 162.74 60.28 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '2.12s' }}
            d="M162.74 67.19 C163.17 68.28 163.46 68.57 164.54 69.00 C163.46 69.43 163.17 69.72 162.74 70.81 C162.30 69.72 162.01 69.43 160.93 69.00 C162.01 68.57 162.30 68.28 162.74 67.19 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '2.04s' }}
            d="M156.50 71.08 C156.86 71.99 157.11 72.24 158.02 72.60 C157.11 72.96 156.86 73.21 156.50 74.12 C156.14 73.21 155.89 72.96 154.98 72.60 C155.89 72.24 156.14 71.99 156.50 71.08 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '2.10s' }}
            d="M150.26 67.29 C150.68 68.32 150.95 68.59 151.97 69.00 C150.95 69.41 150.68 69.68 150.26 70.71 C149.85 69.68 149.58 69.41 148.55 69.00 C149.58 68.59 149.85 68.32 150.26 67.29 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '2.15s' }}
            d="M150.26 60.19 C150.65 61.15 150.91 61.41 151.88 61.80 C150.91 62.19 150.65 62.45 150.26 63.42 C149.88 62.45 149.62 62.19 148.65 61.80 C149.62 61.41 149.88 61.15 150.26 60.19 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '4s' }}
            d="M156.50 104.30 C156.96 105.44 157.26 105.74 158.40 106.20 C157.26 106.66 156.96 106.96 156.50 108.10 C156.04 106.96 155.74 106.66 154.60 106.20 C155.74 105.74 156.04 105.44 156.50 104.30 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '4.06s' }}
            d="M162.74 108.28 C163.10 109.19 163.34 109.44 164.26 109.80 C163.34 110.16 163.10 110.41 162.74 111.32 C162.37 110.41 162.13 110.16 161.22 109.80 C162.13 109.44 162.37 109.19 162.74 108.28 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '4.12s' }}
            d="M162.74 115.19 C163.17 116.28 163.46 116.57 164.54 117.00 C163.46 117.43 163.17 117.72 162.74 118.81 C162.30 117.72 162.01 117.43 160.93 117.00 C162.01 116.57 162.30 116.28 162.74 115.19 Z"
          />
          <path
            className="spark-saved-plans gold-saved-plans"
            style={{ animationDelay: '4.04s' }}
            d="M156.50 119.08 C156.86 119.99 157.11 120.24 158.02 120.60 C157.11 120.96 156.86 121.21 156.50 122.12 C156.14 121.21 155.89 120.96 154.98 120.60 C155.89 120.24 156.14 119.99 156.50 119.08 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '4.10s' }}
            d="M150.26 115.29 C150.68 116.32 150.95 116.59 151.97 117.00 C150.95 117.41 150.68 117.68 150.26 118.71 C149.85 117.68 149.58 117.41 148.55 117.00 C149.58 116.59 149.85 116.32 150.26 115.29 Z"
          />
          <path
            className="spark-saved-plans"
            style={{ animationDelay: '4.15s' }}
            d="M150.26 108.19 C150.65 109.15 150.91 109.41 151.88 109.80 C150.91 110.19 150.65 110.45 150.26 111.42 C149.88 110.45 149.62 110.19 148.65 109.80 C149.62 109.41 149.88 109.15 150.26 108.19 Z"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_12162_48696"
            x="0"
            y="0"
            width="180"
            height="52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="4"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_12162_48696"
            />
            <feOffset dy="6" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12162_48696"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12162_48696"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_12162_48696"
            x="0"
            y="48"
            width="180"
            height="52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="4"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_12162_48696"
            />
            <feOffset dy="6" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12162_48696"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12162_48696"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_12162_48696"
            x="0"
            y="96"
            width="180"
            height="52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="4"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_12162_48696"
            />
            <feOffset dy="6" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12162_48696"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12162_48696"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Center>
  );
};
